module.exports = __webpack_public_path__ + "media/images/como_funciona/delivery-05e541eeee2a040b58f6fe3ff81c7b9e.png";